import type { ReactNode } from 'react';
import { ThemeTypes } from 'types/Theme.namespace';

enum ORIENTATION {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}

interface OrientationProps {
  orientationSmall: ORIENTATION;
  orientationMedium?: ORIENTATION;
  orientationLarge?: ORIENTATION;
}

interface CardProps extends OrientationProps {
  header: ReactNode;
  image?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
  isDisabled?: boolean;
  className?: string;
  paddingSmall: ThemeTypes.Spacing;
  paddingMedium?: ThemeTypes.Spacing;
  paddingLarge?: ThemeTypes.Spacing;
  gapSmall?: ThemeTypes.Spacing;
  gapMedium?: ThemeTypes.Spacing;
  gapLarge?: ThemeTypes.Spacing;
  fillContainer?: boolean;
}

export { ORIENTATION };
export type { OrientationProps, CardProps };
